import React from "react";
import { Route } from "react-router";
import GoogleAnalytics from "react-ga";

// Initialize with UA code and require enhanced link attribution
GoogleAnalytics.initialize("UA-54298709-3");
GoogleAnalytics.plugin.require("linkid");
const DefiRoute = function (props) {
  let trackPage = page => {
    GoogleAnalytics.set({
      page
    });
    GoogleAnalytics.pageview(page);
  };

  // eslint-disable-next-line
  const page = props.location.pathname + props.location.search;
  //console.log('GA Tracking Page: ' + page);
  trackPage(page);

  // componentDidUpdate(prevProps) {

  //   const currentPage = prevProps.location.pathname + prevProps.location.search;
  //   const nextPage = this.props.location.pathname + this.props.location.search;

  //   if (currentPage !== nextPage) {
  //     //console.log('GA Tracking Page: ' + nextPage);
  //     this.trackPage(nextPage);
  //   }
  // }

  return /*#__PURE__*/React.createElement(Route, props);
};
export default DefiRoute;